import { getSession } from './session'

/**
 * Whether this session may only READ.
 *
 * `mode !== 'live'` rather than `mode === 'demo'`: an absent session is not
 * live either, and a write attempted without one must be refused rather than
 * sent.
 *
 * This is the PLATFORM twin of the app's `lib/demo.ts` predicate, extracted
 * in E5 because product packages may not import app core. The app copy
 * deliberately remains: it reads the session through the app's `lib/session`
 * shim, so suites that `vi.mock('./session')` keep governing demo-write
 * policy there. This one reads core-shell's own session module — a package
 * test steers it by mocking the `@bloo-team/core-shell` barrel (or installing a
 * transient session). E7 moved the search platform here; the app copy
 * stays for the app-resident settings-area libs whose suites mock the app's
 * './session' shim.
 */
export function isDemoSession(): boolean {
  return getSession()?.mode !== 'live'
}
